<template>
    <base-container :isLoading="loading">
        <el-main ref="main" style="
          padding: 0 10px;
          height: 100%;
          display: flex;
          flex-direction: column;
        ">
            <div style="padding: 8px;">
                <el-button icon="el-icon-thumb" size="mini" type="success" @click="batchChange">
                    批量改约
                </el-button>
            </div>

            <el-table height="100%" ref="multipleTable" :data="billList" tooltip-effect="dark" style="width: 100%;flex: 1"
                @selection-change="handleSelectionChange">
                <el-table-column align="center" type="selection" width="55">
                </el-table-column>
                <el-table-column prop="billTime" align="center" label="开单时间" min-width="160">
                </el-table-column>
                <el-table-column prop="id" align="center" label="申请单号" min-width="150">
                </el-table-column>
                <el-table-column prop="patientName" align="center" label="患者姓名" min-width="100">
                </el-table-column>
                <el-table-column prop="projectName" align="center" label="治疗项目" min-width="120">
                </el-table-column>
                <el-table-column prop="reserveDate" align="center" label="预约时间" min-width="170">
                    <template slot-scope="scope">
                        {{ scope.row.reserveDate + " " + scope.row.startPoint + "-" + scope.row.endPoint }}
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="150px" fixed="right">
                    <template slot-scope="scope">

                        <el-button size="mini" type="primary" icon="el-icon-edit-outline"
                            @click="changeReserve(scope.row)">改约</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-main>

        <artisan-dialog title="手动预约" :visible.sync="showDialog" height="80%" width="80%" :isLoading="dialogLoading">
            <ReserveChange v-if="showDialog" ref="recommend" :resId="query.scheduleDate" :resDate="query.scheduleDate"
                :bills="bills" @reserved="reserved"></ReserveChange>
        </artisan-dialog>
    </base-container>
</template>
<script>
import ReserveChange from "../assist/ReserveChange.vue";
import { getChangeReserve } from "@/api/zl/bill";
export default {
    props: ["query"],
    components: { ReserveChange },
    data() {
        return {
            showDialog: false,
            dialogLoading: false,
            loading: false,
            multipleSelection: [],
            billList: [],
            bills: [],
        };
    },
    created() {
        this.getBills();
    },
    computed: {
        scheduleIds() {
            return this.schedules.map(c => c.id);
        }
    },
    methods: {
        getBills() {
            this.loading = true;
            getChangeReserve(this.query.scheduleDate, this.query.resourceId).then((res) => {
                this.billList = res.data.data
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        changeReserve(row) {
            this.bills = []
            this.bills.push(row)
            this.showDialog = true;
        },
        reserved() {
            this.showDialog = false;
            this.getBills();
        },
        batchChange() {
            if (this.multipleSelection && this.multipleSelection.length > 0) {
                this.bills=[];
                this.bills=this.multipleSelection;
                this.showDialog = true;
            } else {
                this.$message({
                    offset: 70,
                    type: "error",
                    message: "请先勾选需要改约的申请单！",
                });
            }
        }
    },
}
</script>